import { TiersType } from '@core-lib/enums';
import { IAutocompleteData, IList, IQualiteTiers, ITiers } from '@core-lib/models';

export function tiersListToString(tiersList: ITiers[], separator: string = ', '): string {
	return tiersList
		? tiersList
				.map(t => {
					if (t.type === TiersType.PersonnePhysique) {
						let nom = t.nom ? t.nom?.toLocaleUpperCase() : '';
						let prenom = t.prenom ? ' ' + t.prenom : '';

						return `${nom} ${prenom}`;
					} else {
						let libelle = t?.formeJuridique ? `${t?.formeJuridique + ' ' + t?.libelle}` : `${t?.libelle}`;
						return `${libelle}`;
					}
				})
				.join(separator)
		: '';
}

export function getQualiteTiersById(qualiteTiersId: IQualiteTiers['id'], qualitesTiers: IQualiteTiers[]): IQualiteTiers {
	return qualitesTiers?.find(q => q.id === qualiteTiersId);
}

export function getQualiteTiersByIdForRetrait(qualiteTiersId: IQualiteTiers['id'], qualitesTiers: IQualiteTiers[]): IQualiteTiers {
	return qualitesTiers.find(q => q.id === qualiteTiersId && q.actif && q.actifDebit);
}

export function filtreTiersListForUniqueTiersPartieValue(
	tiersList: IList<ITiers>,
	partie1Values: string[],
	partie2Values: string[]
): IList<ITiers> {
	tiersList.items = tiersList.items.filter(tiers => {
		if (!partie1Values?.includes(tiers.id) && !partie2Values?.includes(tiers.id)) {
			return tiers;
		} else {
			tiers.disabled = true;
			return tiers;
		}
	});
	return tiersList;
}

export function filtreTiersListForOperation(
	tiersList: IList<ITiers>,
	partie1Values: string[],
	partie2Values: string[]
): IList<ITiers> {
	tiersList.items = tiersList.items.filter(tiers => {
		if (partie1Values?.includes(tiers.id) || partie2Values?.includes(tiers.id)) {
			tiers.complementLabel = partie1Values?.includes(tiers.id) ? ' (Client)' : ' (Adversaire)';
		} 
		return tiers;
	});
	return tiersList;
}

export function getTiersLabel(tiers: IAutocompleteData | ITiers): string {
	// Case Personne physique
	let nom = tiers['nom'] ? tiers['nom'] : '';
	let prenom = tiers['prenom'] ? ' ' + tiers['prenom'] : '';
	// Case Personne morale
	let formeJuridique = tiers['formeJuridique'] ? tiers['formeJuridique'] : '';
	let libelle = tiers['libelle'] ? ' ' + tiers['libelle'] : '';

	// Case IAutocompleteData
	let label = tiers['label'];

	return label ? label : nom + prenom + formeJuridique + libelle;
}
